import { Fragment, useRef, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ExclamationIcon } from "@heroicons/react/outline";
import { useCookies } from "react-cookie";
import Multiselect from "multiselect-react-dropdown";

export default function FilterModal({
  moduleName,
  closeConfirmation,
  updateSubPropertyOptions,
  propertyOptionsData,
  subPropertyOptionsData,
  filterProperties,
  setlocation,
  setpropertyOption,
  setsubPropertyOption,
  setapprovalStatus,
  setareaUnits,
  setminPrice,
  setmaxPrice,
  setfacing,
  location,
  propertyOption,
  subPropertyOption,
  approvalStatus,
  areaUnits,
  minPrice,
  maxPrice,
  facing,
  pifLocations,
  propertyLocationsData,
  setPIFLocations,
  pifLocationsSelectedData,
  setPifLocationsSelectedData,
  clearFilters,
}) {
  const [open, setOpen] = useState(true);
  const [cookies, setCookies] = useCookies(["user"]);
  const propertyLocationUrl = "/pifLocation";

  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root
      show={open}
      as={Fragment}
      afterLeave={() => {
        closeConfirmation();
      }}>
      <Dialog
        as='div'
        className='relative z-[60]'
        initialFocus={cancelButtonRef}
        onClose={() => {
          setOpen(false);
        }}>
        <Transition.Child
          as={Fragment}
          enter='ease-out duration-300'
          enterFrom='opacity-0'
          enterTo='opacity-100'
          leave='ease-in duration-200'
          leaveFrom='opacity-100'
          leaveTo='opacity-0'>
          <div className='fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity' />
        </Transition.Child>

        <div className='fixed z-50 inset-0 overflow-y-auto bg-gray-200 bg-opacity-60'>
          <div className='flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'>
              <Dialog.Panel className='relative bg-gray-100 rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-full'>
                <div className='bg-gray-100'>
                  <div className='sm:flex sm:items-start'>
                    <div className='mt-3 mx-4 text-left'>
                      <Dialog.Title
                        as='h4'
                        className='text-lg leading-6 font-medium'>
                        {moduleName}
                      </Dialog.Title>
                      <div className='mt-2'>
                        <div className='w-full mt-1'>
                          <label
                            htmlFor='location'
                            className={`block text-sm font-medium `}>
                            Location
                          </label>
                          <Multiselect
                            className={`mt-0 focus:ring-0 focus:border-yellow-2 block w-full shadow-sm sm:text-sm rounded-xs`}
                            options={propertyLocationsData}
                            selectedValues={pifLocationsSelectedData}
                            onSelect={(selectedList, selectedItem) => {
                              selectedList.map((item) => {
                                delete item["validflag"];
                                delete item["createdAt"];
                                delete item["updatedAt"];
                              });
                              setPifLocationsSelectedData(selectedList);
                              const pifLocationIds = [];
                              selectedList.map((item) => {
                                pifLocationIds.push(item._id);
                              });
                              setPIFLocations(pifLocationIds);
                              setCookies(
                                "pifviewpiflocations",
                                pifLocationIds.join(","),
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                            }}
                            onRemove={(selectedList, removedItem) => {
                              selectedList.map((item) => {
                                delete item["validflag"];
                                delete item["createdAt"];
                                delete item["updatedAt"];
                              });
                              setPifLocationsSelectedData(selectedList);
                              const pifLocationIds = [];
                              selectedList.map((item) => {
                                pifLocationIds.push(item._id);
                              });
                              setPIFLocations(pifLocationIds);
                              setCookies(
                                "pifviewpiflocations",
                                pifLocationIds.join(","),
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                            }}
                            displayValue='name'
                            style={{
                              chips: {
                                background: "#dea302",
                                borderRadius: "2pt",
                              },
                              multiselectContainer: {
                                color: "#000",
                              },
                              inputField: {
                                "font-size": "13px",
                                padding: "3px 5px 3px 7px",
                                width: "100%",
                                border: "none",
                                boxShadow: "none",
                              },
                              searchBox: {
                                border: "solid 0.5px #777",
                                "font-size": "5px",
                                padding: "1px",
                                background: "#fff",
                              },
                            }}
                          />
                        </div>
                        <div className='w-full mt-1'>
                          <label
                            htmlFor='location'
                            className={`block text-sm font-medium `}>
                            Address
                          </label>
                          <input
                            type='text'
                            name='location'
                            id='location1'
                            placeholder='Address'
                            maxLength='20'
                            defaultValue={location}
                            onChange={(e) => {
                              // filterProperties();
                              setlocation(e.target.value);
                              setCookies("pifviewlocation", e.target.value, {
                                path: "/",
                                maxAge: 300,
                              });
                            }}
                            className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                          />
                        </div>
                        <div className='w-full mt-2'>
                          <label
                            htmlFor='propertyOptionId'
                            className={`block text-sm font-medium `}>
                            Property
                          </label>
                          <select
                            id='propertyOptionId1'
                            name='propertyOptionId'
                            defaultValue={propertyOption}
                            onChange={(e) => {
                              // filterProperties();
                              setpropertyOption(e.target.value);
                              updateSubPropertyOptions(e.target.value);
                              setCookies(
                                "pifviewpropertyOption",
                                e.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                            }}
                            defaultValue=''
                            className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm`}>
                            <option key='0' value=''>
                              Select
                            </option>
                            {propertyOptionsData.length > 0 ? (
                              propertyOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                        </div>
                        <div className='w-full mt-2'>
                          <label
                            htmlFor='subPropertyOptionId'
                            className={`block text-sm font-medium `}>
                            Sub Property
                          </label>
                          <select
                            id='subPropertyOptionId1'
                            name='subPropertyOptionId'
                            defaultValue={subPropertyOption}
                            onChange={(e) => {
                              setsubPropertyOption(e.target.value);
                              setCookies(
                                "pifviewsubPropertyOption",
                                e.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                              // filterProperties();
                            }}
                            className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:ring-yellow-2 focus:border-yellow-2 focus:outline-none sm:text-sm`}>
                            <option key='2' value=''>
                              Select
                            </option>
                            {subPropertyOptionsData.length > 0 ? (
                              subPropertyOptionsData.map((item) => (
                                <option key={item?._id} value={item?._id}>
                                  {item?.name}
                                </option>
                              ))
                            ) : (
                              <option key='3' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                        </div>
                        <div className='w-full mt-2'>
                          <label
                            htmlFor='approvalStatus'
                            className={`block text-sm font-medium `}>
                            Approval Status
                          </label>
                          <select
                            id='approvalStatus1'
                            name='approvalStatus'
                            defaultValue={approvalStatus}
                            onChange={(e) => {
                              setapprovalStatus(e.target.value);
                              setCookies(
                                "pifviewapprovalStatus",
                                e.target.value,
                                {
                                  path: "/",
                                  maxAge: 300,
                                },
                              );
                              // filterProperties();
                            }}
                            className={`block w-full py-2 px-3 border bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm`}>
                            <option key='0' value=''>
                              Select
                            </option>
                            <option value='Approved'>Approved</option>
                            <option value='Unapproved'>Unapproved</option>
                          </select>
                        </div>
                        <div className='w-full mt-2'>
                          <label
                            htmlFor='areaUnits'
                            className={`block text-sm font-medium `}>
                            Area Units (cents)
                          </label>
                          <input
                            type='text'
                            name='areaUnits'
                            id='areaUnits1'
                            placeholder='Area Units (in cents)'
                            maxLength='20'
                            defaultValue={areaUnits !== 0 ? areaUnits : ""}
                            onChange={(e) => {
                              setareaUnits(
                                !isNaN(e.target.value)
                                  ? e.target.value === ""
                                    ? 0
                                    : Number(e.target.value)
                                  : 0,
                              );
                              setCookies("pifviewareaUnits", e.target.value, {
                                path: "/",
                                maxAge: 300,
                              });
                              // filterProperties();
                            }}
                            className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-full shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                          />
                        </div>
                        <div className='w-full mt-2'>
                          <label
                            htmlFor='facing'
                            className='block text-sm font-medium text-gray-700'>
                            Facing
                          </label>
                          <select
                            id='facing1'
                            onChange={(e) => {
                              setfacing(e.target.value);
                              setCookies("pifviewfacing", e.target.value, {
                                path: "/",
                                maxAge: 300,
                              });
                              // filterProperties();
                            }}
                            name='facing'
                            defaultValue={facing}
                            className='mt-0 block w-full py-2 px-3 border  bg-white rounded-sm shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Select</option>
                            <option value='North'>North</option>
                            <option value='South'>South</option>
                            <option value='West'>West</option>
                            <option value='East'>East</option>
                            <option value='North-East'>North-East</option>
                            <option value='North-West'>North-West</option>
                            <option value='South-East'>South-East</option>
                            <option value='South-West'>South-West</option>
                            <option value='North and South'>
                              North and South
                            </option>
                            <option value='East and West'>East and West</option>
                            <option value='Others'>Others</option>
                          </select>
                        </div>
                        <div className='w-full mt-2'>
                          <label
                            htmlFor='areaUnits'
                            className={`block text-sm font-medium `}>
                            Price
                          </label>
                          <div className='flex gap-x-2'>
                            <input
                              type='text'
                              name='minPrice'
                              id='minPrice1'
                              defaultValue={minPrice > 0 ? minPrice : ""}
                              onChange={(e) => {
                                setminPrice(
                                  !isNaN(e.target.value)
                                    ? e.target.value === ""
                                      ? 0
                                      : Number(e.target.value)
                                    : 0,
                                );
                                setCookies("pifviewminPrice", e.target.value, {
                                  path: "/",
                                  maxAge: 300,
                                });
                                // filterProperties();
                              }}
                              placeholder='Minimum'
                              maxLength='13'
                              className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-6/12 shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                            />
                            <input
                              type='text'
                              name='maxPrice'
                              defaultValue={
                                maxPrice < 9999999999999 ? maxPrice : ""
                              }
                              onChange={(e) => {
                                setmaxPrice(
                                  !isNaN(e.target.value)
                                    ? e.target.value === ""
                                      ? 0
                                      : Number(e.target.value)
                                    : 0,
                                );
                                setCookies("pifviewmaxPrice", e.target.value, {
                                  path: "/",
                                  maxAge: 300,
                                });
                                // filterProperties();
                              }}
                              id='maxPrice1'
                              placeholder='Maximum'
                              maxLength='13'
                              className='focus:ring-yellow-2 text-sm focus:border-yellow-2 block w-6/12 shadow-sm sm:text-xs read-only:bg-gray-100 read-only:opacity-50 rounded-sm'
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='bg-gray-100 px-6 py-3 flex space-x-2 justify-between'>
                  <button
                    type='button'
                    className='w-3/12 justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm'
                    onClick={() => {
                      filterProperties();
                      setOpen(false);
                    }}
                    ref={cancelButtonRef}>
                    Cancel
                  </button>
                  <button
                    className='w-3/12 inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-semibold rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                    onClick={(event) => {
                      event.preventDefault();
                      clearFilters();
                    }}>
                    Clear
                  </button>
                  <button
                    className='w-6/12 justify-center px-3 py-1 border-transparent shadow-sm text-sm font-medium rounded-md bg-yellow-2'
                    onClick={(e) => {
                      filterProperties("mobile");
                      setOpen(false);
                    }}>
                    Filter
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
